import React, { FunctionComponent } from 'react';
import { Typography, Grid, Button, Colors } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';
import { AiOutlineWarning } from 'react-icons/ai';

// Components
import DashedList from 'components/DashedList';
import StyledContainer from 'components/StyledContainer';
import BaseModal, { ModalActions } from 'components/Modals/BaseModal';

// styled components
import { BlueTypography } from 'components/SharedStyledElements';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';

const { Cell } = Grid;

const ContentWrapper = styled.div`
  border: 1px solid ${Colors.gray};
  border-radius: 3px;
  padding: 20px;
  background: ${Colors.lightGray};
`;

const Title = styled(BlueTypography)`
  text-align: center;
`;

const StyledWarningIcon = styled(AiOutlineWarning)`
  color: ${Colors.red};
`;

interface Props {
  handleRemoveWidgetSettings: () => void;
}

const DeleteWidgetSettingsModal: FunctionComponent<Props> = ({ handleRemoveWidgetSettings }) => {
  const handleDeleteWidgetSettings = async (closeModal: () => void) => {
    await handleRemoveWidgetSettings();
    closeModal();
  };

  return (
    <BaseModal
      modalName={ModalNames.WidgetRemove}
      title="Confirm your action"
      render={({ closeModal }: ModalActions) => (
        <>
          <ContentWrapper>
            <Title variant="h6">Are you sure you want to delete this widget settings?</Title>
            <Typography variant="p">
              <StyledWarningIcon /> By setting swiitch to off you will disable the chat for the asset along with
              deleting all its settings. <br />
            </Typography>
            <Typography variant="p">
              This includes the following:
              <DashedList>
                <li>Chat room ID</li>
                <li>Chat room title</li>
              </DashedList>
            </Typography>
            <Typography variant="p">
              The only data we will keep in the system is the LiveLike integration data.
            </Typography>
          </ContentWrapper>
          <StyledContainer columns={3} alignContent="center" justifyContent="center" margin="2rem 0 0 0">
            <Cell middle left={2}>
              <Button fullWidth type="button" onClick={closeModal}>
                Oops, no!
              </Button>
            </Cell>
            <Cell middle left={3}>
              <Button
                fullWidth
                type="button"
                onClick={() => handleDeleteWidgetSettings(closeModal)}
                buttonModifiers={['buttonPrimary']}
              >
                Yes, delete!
              </Button>
            </Cell>
          </StyledContainer>
        </>
      )}
    />
  );
};

export default DeleteWidgetSettingsModal;
